import { useCallback, useRef } from "react";
import shopBurst from "../../assets/img/shop-burst.png";
import { useModalMotion } from "../../hooks/useModalMotion";

function QuitLeaveModal({ show, onStay, onLeave }) {
  const actionRef = useRef(null);
  const finish = useCallback(() => {
    const action = actionRef.current;
    actionRef.current = null;
    action?.();
  }, []);
  const { requestClose, motionClassName } = useModalMotion(finish, {
    open: show,
  });

  const runThenClose = (action) => {
    actionRef.current = action;
    requestClose();
  };

  if (!show) return null;

  return (
    <div
      className={`quitLeave${motionClassName}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="quitLeaveTitle"
    >
      <button
        type="button"
        className="quitLeave__backdrop"
        onClick={() => runThenClose(onStay)}
        aria-label="Stay and continue"
      />
      <div className="quitLeave__card">
        <div className="quitLeave__titleRow">
          <img
            className="quitLeave__burst quitLeave__burst--left"
            src={shopBurst}
            alt=""
            aria-hidden="true"
          />
          <h2 id="quitLeaveTitle" className="quitLeave__title">
            Leaving already?
          </h2>
          <img
            className="quitLeave__burst"
            src={shopBurst}
            alt=""
            aria-hidden="true"
          />
        </div>
        <p className="quitLeave__copy">
          YOUR SESSION WILL BE LOST IF YOU LEAVE THIS PAGE. ARE YOU SURE YOU WANT TO QUIT?
        </p>
        <div className="quitLeave__actions">
          <button
            type="button"
            className="quitLeave__stay"
            onClick={() => runThenClose(onStay)}
          >
            CONTINUE
          </button>
          <button
            type="button"
            className="quitLeave__leave"
            onClick={() => runThenClose(onLeave)}
          >
            QUIT
          </button>
        </div>
      </div>
    </div>
  );
}

export default QuitLeaveModal;
